/**
 * Centralized query key management for Radar de Desempenho
 *
 * Hierarchy:
 * ['radar']
 *   ['radar', 'search', query]
 *   ['radar', 'employee', employeeId, period]
 *   ['radar', 'tree', employeeId, depth, period]
 *   ['radar', 'org-overview', period]
 *   ['radar', 'comparison', idA, idB, period]
 *   ['radar', 'matrix', employeeId, cycleId]
 */
export const radarKeys = {
  all: ['radar'] as const,

  search: (query: string) =>
    [...radarKeys.all, 'search', query] as const,

  radar: (employeeId: string, period?: { startDate?: string; endDate?: string }) =>
    [...radarKeys.all, 'employee', employeeId, period] as const,

  tree: (employeeId: string, depth: number, period?: { startDate?: string; endDate?: string }) =>
    [...radarKeys.all, 'tree', employeeId, depth, period] as const,

  orgOverview: (period?: { startDate?: string; endDate?: string }) =>
    [...radarKeys.all, 'org-overview', period] as const,

  comparison: (idA: string, idB: string, period?: { startDate?: string; endDate?: string }) =>
    [...radarKeys.all, 'comparison', idA, idB, period] as const,

  matrix: (employeeId: string, cycleId?: string) =>
    [...radarKeys.all, 'matrix', employeeId, cycleId] as const,
}
